<p>rates works!</p>
